export default __webpack_public_path__ + "static/media/Giancarlo Possemato.6a05f349.jpg";